import { useEffect, useState } from 'react'
import { MOBILE_BREAKPOINT_PX } from '@/shared/constants/timings'

export function useIsMobile(
  breakpoint: number = MOBILE_BREAKPOINT_PX,
): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint,
  )

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [breakpoint])

  return isMobile
}
